import gql from 'graphql-tag'

export const REGISTER_CHANNEX_WEBHOOK_MUTATION = gql`
  mutation RegisterChannexWebhook {
    registerChannexWebhook {
      ok
      webhookId
      error
    }
  }
`
